export enum FailClassroomImportReason {
  Exists = 'Classroom is already imported.',
  GoogleClassroom = 'Google Classroom request failed',
}
